import React from "react";

import { useEventTracker } from "@/hooks/useEventTracker";

import Chip from "@/components/botanic/Chip";

type Props = { tags?: string[] };

const NewsTags: React.FC<Props> = ({ tags }) => {
  const { publishEvent } = useEventTracker();
  return tags ? (
    <div className="flex flex-row flex-wrap" data-testid="article-tags">
      {tags.map((tag) => {
        const slug = tag.replaceAll(" ", "-").toLowerCase();
        return (
          <Chip
            href={`/news/tags/${slug}`}
            key={`tag-${slug}`}
            className="mr-sm mb-sm"
            onClick={() =>
              publishEvent({
                action: "click",
                category: "article tag",
                label: `${tag} /news/tags/${slug}`,
              })
            }
          >
            {tag}
          </Chip>
        );
      })}
    </div>
  ) : null;
};

export default NewsTags;
